import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import { initIssueReporter } from './lib/issue-reporter';
import { ErrorBoundary } from './components/ErrorBoundary';
import './components/report-problem.css';

// Catch uncaught errors from the very first line so a crash during startup
// still reaches the issue log.
initIssueReporter({ app: 'moderation', release: __RELEASE__ });

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
